<template>
  <div class="professional-personnel-page">
    <el-card class="page-card">
      <div slot="header" class="card-header">
        <h2>职业人员</h2>
      </div>
      <div class="page-content">
        <p>职业人员页面内容</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ProfessionalPersonnel',
  data() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>
.professional-personnel-page {
  padding: 20px;
}

.page-card {
  min-height: 500px;
}

.card-header h2 {
  margin: 0;
  color: #333;
}

.page-content {
  padding: 20px 0;
}
</style>
